import { render } from "./ToggleButtonsField.vue?vue&type=template&id=c60579f0"
import script from "./ToggleButtonsField.vue?vue&type=script&lang=js"
export * from "./ToggleButtonsField.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__